module.exports = __webpack_public_path__ + "static/media/iphone.1ab76465.jpg";